<template>
  <span class="text-xs text-white/100 font-normal"
    >Version {{ versionHistory[0].version }}</span
  >
</template>
<script>
import semanticVersion from "@/utils/composables/version";
export default {
  setup() {
    const { versionHistory } = semanticVersion();
    return {
      versionHistory,
    };
  },
};
</script>
